import withOthersNotSelected from "../../assets/images/svg/withOthersNotSelected.svg";
import nuvamaSelected from "../../assets/images/svg/nuvamaSelected.svg";
import withOtherSelected from "../../assets/images/svg/withOtherSelected.svg";
import nuvamaNotSelected from "../../assets/images/svg/nuvamaNotSelected.svg";
import { Observer } from "mobx-react";
import SettingsStore from "../../store/SettingsStore";

const getImageSource = (type) => {
  if (type == 0) {
    if (SettingsStore.report_type == 0) {
      return nuvamaSelected;
    }
    return nuvamaNotSelected;
  } else {
    if (SettingsStore.report_type == 1) {
      return withOtherSelected;
    }
    return withOthersNotSelected;
  }
};

const handleReportType = (type) => {
  switch (type) {
    case 0:
      if (SettingsStore.report_type == 0) {
        SettingsStore.report_type = 1;
        SettingsStore.callReportType(SettingsStore.report_type);
        return;
      }
      SettingsStore.report_type = 0;
      break;
    case 1:
      if (SettingsStore.report_type == 1) {
        SettingsStore.report_type = 0;
        SettingsStore.callReportType(SettingsStore.report_type);
        return;
      }
      SettingsStore.report_type = 1;
      break;
  }
  SettingsStore.callReportType(type);
};

const checkSelection = (type) => {
  if (type == 0) {
    if (SettingsStore.report_type == 0) {
      return true;
    }
    return false;
  } else {
    if (SettingsStore.report_type == 1) {
      return true;
    }
    return false;
  }
};

const ReportType = () => {
  return (
    <Observer>
      {() => (
        <div className="investments_held_with">
          <div className="investments_held_with_notice_text description">
            <p>
              1. Transfer In: Returns in the monthly report/App/Web Portal will
              be since the day of joining nuvama.
            </p>
            <p>
              2. Inception Date: Returns in the monthly report/App/Web Portal
              will be since the actual day of transactions
            </p>
          </div>
          <div className="nuvama_selector_main">
            <div
              className={`with_nuvama ${
                checkSelection(0) || SettingsStore.report_type == null
                  ? "active"
                  : ""
              }`}
              onClick={() => {
                handleReportType(0);
              }}
            >
              <div className="logo">
                <img
                  src={
                    SettingsStore.report_type == null
                      ? nuvamaSelected
                      : getImageSource(0)
                  }
                  alt="With_nuvama"
                />
              </div>
              <div className="title1">Transfer In Date</div>
            </div>
            <div
              //   style={{
              //     cursor: SettingsStore.isheldaway ? "pointer" : "not-allowed",
              //   }}
              className={`without_nuvama ${checkSelection(1) ? "active" : ""}`}
              onClick={() => {
                handleReportType(1);
              }}
            >
              <div className="logo">
                <img src={getImageSource(1)} alt="with_others" />
              </div>
              <div className="title1">Inception Date</div>
            </div>
          </div>
          <div className="investments_held_with_notice_text">
            Kindly note that any changes in the above setting would be reflected
            on your respective portfolio post 24 hrs
          </div>
        </div>
      )}
    </Observer>
  );
};

export default ReportType;
